import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AgrSharedModule } from '@next/core-lib/shared';

import { CustomDialogComponent } from './components/dialog/custom-dialog.component';
import { FertilizationLegalStandardApiService } from './services/fertilization-legal-standard-api.service';

@NgModule({
  declarations: [CustomDialogComponent],
  imports: [AgrSharedModule, MatButtonModule, MatIconModule],
  exports: [AgrSharedModule, CustomDialogComponent],
  providers: [FertilizationLegalStandardApiService],
})
export class SharedModule {}
